import { Component, HostBinding, Input } from '@angular/core';

type ContainerSize = 'tablet' | 'desktop-small' | 'desktop-xlarge' | 'fluid';

@Component({
  selector: 'fl-container',
  template: `
    <ng-content></ng-content>
  `,
  styleUrls: ['./container.component.scss'],
})
export class ContainerComponent {
  @HostBinding('attr.size')
  @Input()
  container: ContainerSize;
}



// WEBPACK FOOTER //
// /mnt/jenkins-slave-workspace/workspace/gaf-build-webapp-compat/webapp/src/app/@shared/ui/container/container.component.ts